<template>
  <div class="v-outside" :class="{'in-cur':onout}">
		<div class="v-outmark"></div>
		<div class="v-outmain" @mouseenter="goOutSide(true)" @mouseleave="goOutSide(false)">
			<ul class="v-outlist">
				<li title="Dr.COM Billingware 统一登录平台">
					<a href="#" @click="triggerNavChange(null)">
						<a-icon type="home" />
						<span>主页</span>
					</a>
				</li>
				<li v-for="v in products" :title="v.detail" :key="v.fid">
					<template v-if="v.running">
						<a :href="v.target === '_blank' ? (v.contextPath + v.href) : ('#' + v.name)" :target="v.target === '_blank' ? '_blank' : ''" @click="triggerNavChange(v)">
							<a-icon type="link" />
							<span>{{v.title}}</span>
						</a>
					</template>
					<template v-else>
						<a href="javascript:" class="no-service">
							<a-icon type="disconnect" />
							<span class>{{v.title}}</span>
						</a>
					</template>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
  name: 'OutSide',
	props: ['products', 'onout'],
	methods: {
		goOutSide(flag, time) {
			this.$emit('out-side', flag, time);
		},
		triggerNavChange(view) {
      if (view === null) {
        this.$emit('nav-index')
      } else if (view.type !== '_blank') {
        this.$emit('nav-change', view)
      }
			this.goOutSide(false, 0);
    }
	}
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import './index.scss';
a.no-service, a.no-service:hover, a.no-service:active, a.no-service:focus, a.no-service:visited {
	text-decoration: line-through;
	color: gray;
}
</style>
